import isApiError from "@insite/client-framework/Common/isApiError";
import { post } from "@insite/client-framework/Services/ApiService";

const url = "/api/v1/accountDetails";

export async function changeCustomerService(
    customerNumber: string,
) {
    try {
        const result = await post<
            { customerNumber: string }
        >(`${url}?customerNumber=${customerNumber}`);

        return {
            successful: true,
            result,
        };
        
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}
